import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Data.scss";

const ABDMData = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [hash]);

  return (
    <div
      className="data-container"
      // style={{
      //   backgroundImage: "url('../../assets/images/backgrounds/2.jpg')",
      // }}
    >
      <div id="abdm" className="textitem">
        <h5>What is ABDM? </h5>
        <p>
          Ayushman Bharat Digital Mission (ABDM): The Future of Digital
          Healthcare in India
        </p>
        <p>
          The Ayushman Bharat Digital Mission (ABDM) has been launched by the
          Government of India for promoting digitization of healthcare and
          creating an open interoperable digital health ecosystem for the
          country. It aims to do so by prescribing common health data standards,
          developing core modules such as registry of health facilities,
          healthcare professionals etc required for interoperability; so that
          various digital health systems can interact with each other by
          enabling seamless sharing of data across various healthcare providers
          who may be using different digital health systems. Digitization of
          processes in the healthcare institutions shall be taken up by
          dovetailing various resources. Thus, ABDM seeks to bridge the gap
          among multiple stakeholders that are the part of the healthcare
          ecosystem.
        </p>
        <p>
          The pilot project was launched with the name of National Digital
          Health Mission (NDHM) in the six union territories of Ladakh,
          Chandigarh, Dadra and Nagar Haveli and Daman and Diu, Puducherry,
          Lakshadweep and Andaman and Nicobar Islands on 15th August 2020. The
          nationwide rollout of this pilot project was announced by Hon'ble
          Prime Minister Shri. Narendra Modi on 27th September 2021 with the
          name “Ayushman Bharat Digital Mission” (ABDM).
        </p>
      </div>

      <div id="processes" className="textitem">
        <h5>Processes </h5>
        <p>
          ABDM Compliance are safeguarded by scopes and related test plan as
          mandated by NHA and can be divided into 3 milestones:
        </p>
        <ul>
          <li>
            Milestone 1: ABHA Number creation and capture & verification for
            seamless patient registration.
          </li>
          <li>
            Milestone 2: Building Health Information Provider (HIP) services to
            share digital records via Personal Health Records (ABHA) app.
          </li>
          <li>
            Milestone 3: Developing Health Information User (HIU) services to
            provide view of patient’s medical history to authorized healthcare
            workers with complete consent.
          </li>
        </ul>
      </div>

      <div id="legal" className="textitem">
        <h5>Legal Compliance</h5>
        <p>
          The current legal framework in India consisting of various laws such
          as the Information Technology Act, 2000 including the relevant
          regulations and rules including various judgements of Hon’ble Supreme
          Court such as Puttaswamy V/s Union of India (2017), etc provide
          adequate legal framework for implementation of such a digital mission.
        </p>
        <p>
          Foremost, it is necessary to understand what exactly is being
          attempted by implementing the ABDM. Currently, all the healthcare
          providers create and store the health records of patients seeking
          healthcare from them. These are either stored physically (in paper
          format) and/or digitally.
        </p>
        <p>
          Digital systems are being used as per the choice of respective
          healthcare provider. The data shall continue to be stored in the same
          place even after implementation of this mission.
        </p>
        <p>
          ABDM is essentially providing an interoperable platform between
          different digital health systems. The storage of data remains at the
          same place where it is currently residing. Therefore, no special law
          is required to be enacted as such for implementing this particular
          mission.
        </p>
        <p>
          However, with due consideration to the sensitivity of health data, the
          ‘Health Data Management Policy’ has been formulated which emphasizes
          upon ‘consent-based arrangement’. It is explicitly laid out that the
          health record should be linked to ABHA after taking consent of the
          patient for the purposes for which consent is provided. Such digital
          health ecosystem based on consent-based arrangement has adequate legal
          backing in the current legal framework of India.
        </p>
      </div>

      <div id="faqs" className="textitem">
        <h5>ABDM FAQs</h5>
        <p>
          <strong>Q1. Why ABHA and Not Aadhaar?</strong>
          <br />
          The Section 7 of the Aadhaar and Other Laws (Amendment) Act, 2019
          clearly states that “Every Aadhaar number holder to establish his
          identity, may voluntarily use his Aadhaar number in physical or
          electronic form by way of authentication or offline verification, or
          in such other form as may be notified, in such manner as may be
          specified by regulations.”
          <br />
          The Aadhaar Act provides for the use of Aadhaar number as proof of
          identity of a person, subject to authentication. However, the mandate
          of mandatory linkage of Aadhaar is restricted to availing only Direct
          Benefits Transfers (DBTs) and it can’t be for any other purpose. Thus,
          Aadhaar number holders may only voluntarily use Aadhaar Number to
          establish their identity. Therefore, a distinct, independent, unique
          identifier is required to be identified as a ABHA and hence, the ABHA
          is different from the Aadhar ID and one should not be confused for the
          other.
        </p>
        <p>
          <strong>
            Q2. What is the difference between ABHA and Ayushman card/Golden
            card?
          </strong>
          <br />
          These two are different. The National Health Authority implements two
          distinct health programs:
          <br />
          <em>
            Ayushman Bharat Pradhan Mantri Jan Arogya Yojana (AB PM-JAY)
          </em>{" "}
          This is a program aimed at providing health cover of Rs 5 Lakh per
          family per year for secondary and tertiary care hospitalization to
          nearly 54 crore beneficiaries that form the bottom 40% of the Indian
          population. The households included are based on the deprivation and
          occupational criteria of Socio-Economic Caste Census 2011 (SECC 2011)
          for rural and urban areas respectively This program was started in
          2018. Under this program, the beneficiaries (54 crore) are entitled
          for getting an Ayushman card (earlier known as Golden Card). The
          beneficiary can use this card for accessing cashless healthcare
          services in any of the empaneled hospitals throughout India. For more
          details, please visit " ".
          <br />
          The Ayushman Card should not be confused with ABHA. ABHA is provided
          under different scheme (Ayushman Bharat Digital Mission) which is
          implemented by the same office (National Health Authority).
          <br />
          National Health Authority started implementing Ayushman Bharat Digital
          Mission (earlier known as National Digital Health Mission) in the six
          union territories of Ladakh, Chandigarh, Dadra and Nagar Haveli and
          Daman and Diu, Puducherry, Lakshadweep and Andaman and Nicobar Islands
          from August 2020. ABDM was rolled out throughout India on 27th
          September 2021. Under ABDM, all citizens can create ABHAs. These ABHAs
          are not limited to 54 crore eligible beneficiaries of Ayushman Bharat
          Pradhan Mantri Jan Arogya Yojana. This ABHA does not provide services
          of any scheme but facilitates linkage of health records across all the
          hospitals (government and private). Even though only ABHA number is
          sufficient for use, feature of taking printout is also provided in the
          ABDM platform for ease of carrying and remembering the number. Such
          ABHA card of Ayushman Bharat Digital Mission should not be confused
          with Ayushman Card of Ayushman Bharat PMJAY.
        </p>
        <p>
          <strong>
            Q3. How to use ABHA Application to access Health records?
          </strong>
          <br />
          PHR stands for Personal Health Record. It is a unique address similar
          to a virtual payment address or email ID which is created by an
          individual, as per their choice. This is provided as it is easier to
          remember such an address rather than remembering a fourteen-digit
          ABHA. For example - ajay@ndhm, abc@ndhm, etc. The ABDM Health Records
          are an electronic format of health-related information on an
          individual that can be drawn from multiple sources while being
          managed, shared, and controlled by the individual. The record can be
          shared on consent via a citizen facing Public Health Record (PHR)
          application.
        </p>
        <p>
          <strong>
            Q4. How is the Security of Health Records are ensured by ABDM
            System?
          </strong>
          <br />
          PHR stands for Personal Health Record. It is a unique address similar
          to a virtual payment address or email ID which is created by an
          individual, as per their choice. This is provided as it is easier to
          remember such an address rather than remembering a fourteen-digit
          ABHA. For example - ajay@ndhm, abc@ndhm, etc. The ABDM Health Records
          are an electronic format of health-related information on an
          individual that can be drawn from multiple sources while being
          managed, shared, and controlled by the individual. The record can be
          shared on consent via a citizen facing Public Health Record (PHR)
          application. ABDM does not store any medical records. These are always
          created and stored by healthcare providers as per their retention
          policies and this will continue. ABDM only facilitates secure data
          exchange between the intended stakeholders on ABDM network after the
          patient’s consent.
          <br />
          Through ABDM compliant applications, patients will also be able to
          choose which health records they want to link with their ABHAs,
          securely store their digital health records on their devices, securely
          access their records online, and securely share their health records
          with healthcare providers after the patient’s consent.
          <br />
          It is a reference application created by the government which is
          available on the Google Play Store. It can be used to: Only the data
          collected for registries such as ABHA registry, Healthcare
          Professional Registry and Healthcare Facility Registry is stored
          centrally. It is necessary for these datasets to be stored centrally
          because they are essential to provide interoperability, trust, and
          identification and single source of truth across different digital
          health systems. This data is stored and processed in secure and safe
          manner.
        </p>
        <p>
          <strong>Q5: Where can I post any feedback or concerns?</strong>
          <br />
          <a
            style={{ color: "blue" }}
            href="https://grievance.abdm.gov.in/grievance/v3/"
          >
            https://grievance.abdm.gov.in/grievance/v3/
          </a>
        </p>
        <p>
          <strong>Grievance Redressal Workflow</strong>
          <br />
          Any citizen can register a grievance/complaint to the ABDM via online
          grievance portal/Inland Post/Call Centre.
          <br />
          When a user registers a grievance on the Grievance/IT Incident portal
          by providing relevant information, e.g., name, contact number, type of
          query etc., a grievance id will be generated on the portal against the
          query.
          <br />
          After the registration of the query on Grievance portal, that query
          will be looked into by ABDM Grievance Help-desk Team.
          <br />
          The grievance help-desk team will resolve the grievance however,
          depending upon the nature of the query it may be further escalated to
          the functional team for resolution.
          <br />
          Grievance can be tracked on the ABDM Grievance redressal portal, using
          your Unique application number. Once the resolution is done, it is
          published on the grievance portal and the user can view his/her
          resolution by providing the grievance ID.
          <br />
          As per the Health Data Management policy, the TAT to resolve a
          grievance is 30 days.
        </p>
        <p>
          <strong>Q6. What is AB PM-JAY?</strong>
          <br />
          Ayushman Bharat Pradhan Mantri Jan Arogya Yojana (AB PM-JAY) is a
          scheme to provide health cover or health insurance of up to INR 5 lakh
          per family per year for certain beneficiaries. Like ABDM, it is also
          implemented by the National Health Authority. AB PM-JAY is leveraging
          the platform of ABDM, so that its delivery becomes more efficient and
          transparent. Similarly, any other such scheme or health programme can
          leverage the common building blocks or design of ABDM so that its
          efficiency can improve. The integration of ABDM with AB PM-JAY is like
          its integration with any other digital health system such as the one
          of NIKSHAY (anti-TB programme), CoWIN (COVID vaccination portal),
          hospitals, etc. Apart from this integration, both the schemes have
          different goals. Thus, they are two different schemes being
          implemented by the same authority/office.
        </p>
        <p>
          <strong>Q7. What is Ayush?</strong>
          <br />
          ABDM is being implemented by National Health Authority, which is an
          attached office of Ministry of Health & Family Welfare (MoHFW). MoHFW
          is separate ministry than the Ministry of Ayurveda, Yoga, Naturopathy,
          Unani, Siddha, Sowa-Rigpa and Homoeopathy i.e. Ministry of AYUSH.
          Thus, MoHFW and NHA are separate from Ministry of AYUSH
          administratively. The word Ayushman Bharat in this case denotes our
          vision for an India with long life and AYUSH in ministry of AYUSH is
          an acronym representing different systems of medicines. However, ABDM
          has been designed to onboard healthcare facilities and healthcare
          professionals from all the systems of medicine including AYUSH.
        </p>
        <p>
          <strong>
            Q8. What are the important Registries set up under ABDM?
          </strong>
          <br />
          These are digital repositories that seek and hold critical information
          about Health facilities such as Hospitals and Clinics, and Healthcare
          Professionals such as Doctors, Staff Nurses etc.
          <br />
          These registries help us list and identify nearest healthcare support
          available for any medical assistance.
          <br />
          The two key registries linked to ABDM are:
          <br />
          Health Facility Registry
          <br />
          Health Professional Registry
        </p>
        <p>
          <strong>Q9. How Privacy of Patients is being handled in ABDM?</strong>
          <br />
          Citizens will be able to sign up independently with a consent manager
          of their choice to participate in consent-based data sharing.
          <br />
          The proposed architecture will not only safeguard privacy but will
          also spur innovation by unlocking the financial value of health data
          locked up in institutional fragmented systems thereby offering
          multiple health product including insurance and other health related
          services.
          <br />
          These entities will be able to innovate different consent experiences
          for smartphones/feature phones users while targeting different
          segments including illiterate and minors.
          <br />
          By being the bridge between data principal at one end and data user at
          the other end, it will play a pivotal role in processing & approval of
          consents.
          <br />
          Handling data access transactions that require a comprehensive and
          longitudinal perspective.
        </p>
        <p>
          <strong>Q10. What ABDM means for me?</strong>
          <br />
          <em>Interoperability</em>: ABDM promotes seamless data exchange,
          allowing Hlthtek.com to effortlessly integrate with other healthcare
          systems. This means:
          <br />
          Sharing patient records: Easily exchange information with other
          providers, eliminating redundant data entry and ensuring complete
          patient history is available.
          <br />
          Connecting with other platforms: Seamless integration with government
          health schemes, insurance companies, and other digital health
          solutions for a streamlined workflow.
          <br />
          <em>Improved Efficiency</em>: ABDM facilitates a paperless system,
          saving you time and resources.
          <br />
          Digital records: Reduce paperwork, simplify patient data management,
          and streamline billing processes.
          <br />
          Centralized access: Access patient information anytime, anywhere, for
          informed decision-making.
          <br />
          <em>Enhanced Patient Care</em>: ABDM empowers patients to take control
          of their health:
          <br />
          Health IDs: Patients have unique digital health IDs, ensuring their
          data is secure and easily accessible.
          <br />
          Health Records: Patients can view and share their health records,
          fostering greater transparency and engagement in their care.
          <br />
          <em>Opportunities for Growth</em>: ABDM creates a thriving digital
          health ecosystem, providing:
          <br />
          New revenue streams: Leverage digital health services, telehealth
          consultations, and data analytics to create new business
          opportunities.
          <br />
          Innovation: Contribute to the development of innovative digital health
          solutions that improve patient outcomes and enhance healthcare
          delivery.
        </p>
        {/* <p>
                    <strong>ABDM Demo - Connector (HT-Bridge)</strong>
                    <br />
                    <a href="link_to_ht_bridge_recording">Link to HT-Bridge Recording</a>
                </p>
                <p>
                    <strong>ABDM Demo - Health Repository Provider (HT-HRP)</strong>
                    <br />
                    <a href="link_to_ht_hrp_recording">Link to HT-HRP Recording</a>
                </p>
                <p>
                    <strong>Electronic Health Record (EHR) Demo</strong>
                    <br />
                    <a href="link_to_ehr_recording">Link to EHR Recording</a>
                </p>
                <p>
                    <strong>Digital Health Incentive Schemes (DHIS)</strong>
                    <br />
                    <a href="https://abdm.gov.in/DHIS">https://abdm.gov.in/DHIS</a>
                </p> */}
      </div>
    </div>
  );
};

export default ABDMData;
